import {
  getCustomerModel,
  update
} from '../../services/entities/customerService'
import { bugSnag, printLiliHeaders } from '../../services/analyticsService'
import { createErrorObject } from '../../services/entities/onboardingService'
import { params } from '../../localData/index'
import { isFromLiliApp } from '../../services/UtilService'
import mixpanel from '../../plugins/mixPanel'
import router from '../../router/router'
import { loginUser } from '../../services/auth'

export const customerModule = {
  namespaced: true,
  state: {
    data: getCustomerModel()
  },
  mutations: {
    setKeyValue (state, payload) {
      let { prop, value } = payload
      state.data = { ...state.data, [prop]: value }
    },
    setMultiKeyValues (state, payload) {
      state.data = { ...state.data, ...payload }
    }
  },
  actions: {
    async updateCustomer ({ commit, state, dispatch }, ajaxData) {
      const { self, endPoint } = ajaxData
      try {
        let res = await update(ajaxData)
        // [Cross module] mutation onboarding module - save lastResponse
        commit(
          'onboarding/setKeyValue',
          { prop: 'lastResponse', value: JSON.stringify(res) },
          { root: true }
        )
        // Return res to component
        return res
      } catch (err) {
        let httpStatus = ''
        let logId = ''
        let errorCode = ''
        let errorData = {}
        if (err) {
          httpStatus = JSON.stringify(err.rawError.status)
          if (err.rawError.headers) {
            logId = err.rawError.headers.get('lililogid')
          }
          err.data && (errorCode = JSON.stringify(err.data.errors[0].code))
        }
        // If token Expired show UserMessage & handle flow
        if (httpStatus === params.responseCodeEnums.tokenExpired) {
          // httpStatus == 401
          mixpanel.track('Will View Expire Token', { errorCode: errorCode })

          // Add JWT error code
          commit(
            'errors/updateUserMessage',
            {
              isActive: true,
              popupType: 'TokenExpire'
            },
            { root: true }
          )
          errorCode = '401'
        }
        if (errorCode === params.responseCodeEnums.EMAIL_ALREADY_EXISTS) {
          self.$router.push({name: 'accountExists'})
        }
        if (errorCode === params.responseCodeEnums.UBO_SSN_ALREADY_EXISTS) {
          commit(
            'errors/updateUserMessage',
            {
              isActive: true,
              popupType: 'CantAddUboError'
            },
            { root: true }
          )
          throw createErrorObject(errorCode, self)
        }
        errorData = createErrorObject(errorCode, self)
        if (errorData) {
          // Report to mixpanel
          mixpanel.track('Form Error Shown', { fieldError: errorData.field })
          mixpanel.track('Error Occurred during Onboarding', {
            errorCode: errorData.errorCodeName,
            errorMessage: errorData.content,
            origin: state.data.fromRoute,
            fieldName: errorData.field,
            errorHandler: 'Server',
            isExpectedError: !errorData.isBusinessLogicError,
            isFromLiliApp: isFromLiliApp()
          })

          // Set the related field the error content
          dispatch(
            'errors/setFieldContent',
            { field: errorData.field, content: errorData.content },
            { root: true }
          )
          // BusinessLogicError? report bugSnag
          errorData.isBusinessLogicError &&
            bugSnag('notify', JSON.stringify(errorData))
          // kycFailed? redirect user to errorData.redirectUrl
          errorData.isFailure &&
            self.$router.push(errorData.redirectUrl).catch(error => {
              console.error(errorData)
              if (
                error.name !== 'NavigationDuplicated' &&
                !error.message.includes(
                  'Avoided redundant navigation to current location'
                )
              ) {
                bugSnag(
                  'notify',
                  `Error object redirect issue: ${JSON.stringify(errorData)}`
                )
              }
            })
        }
        // Print lili headers (Appear on console error)
        logId && printLiliHeaders(endPoint, logId)
        throw errorData
      }
    },
    async get (context, ajaxData) {
      try {
        let res = await update(ajaxData)
        return res
      } catch (err) {}
    },
    async refreshLogin ({ commit, state, dispatch, rootState }) {
      return new Promise(async (resolve, reject) => {
        const token =
          router.currentRoute.query.token ||
          rootState.onboarding.data.partnerToken
        commit(
          'onboarding/setKeyValue',
          {
            prop: 'partnerToken',
            value: token
          },
          {
            root: true
          }
        ) // this call may be redudnant in some cases, but it's not expensive and wer'e better safe then sorry when it comes to tokens
        if (!token) return reject(new Error('No partner token'))
        const customerData = await loginUser(token)
        commit('setMultiKeyValues', {
          accessToken: customerData.accessToken
        })
        resolve()
      })
    }
  },
  getters: {
    data ({ data }) {
      // Return shallow copy, to avoid mutation out of module scope
      return { ...data }
    }
  }
}



// WEBPACK FOOTER //
// ./src/RF_store/modules/customer.module.js